
/**
 *
 * @param {string} dashedString - Needs to be in the format of 'data-test-id'.
 *                                All underscore letters and all words separated by a dash.
 */
export const camelCase = (dashedString) => {
  return dashedString.toLowerCase().replace(/-(.)/g, function(match, letterAfterDash) {
    return letterAfterDash.toUpperCase()
  })
}
